/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TrackRecords = {
    type: 'array',
    contains: {
        type: 'Track',
    },
};